<template>
  <span class="flag" :class="[colorClass]">{{ text }}</span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'green'
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    colorClass () {
      return `flag__${this.color}`
    }
  }
}
</script>


<style lang="scss">
  .flag {
    display: block;
    padding: 5px 12px !important;
    border-radius: 3px;
    color: #ffffff;
    font-size: rem(11);
    text-transform: uppercase;

    &__green {
      background-color: color(green);
    }
    &__red {
      background-color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// Flag.vue?25fdfbee